import styled from 'styled-components';

export const IonWrapper = styled('div')`
  .otp-row {
    display: flex;
    justify-content: center;
  }

  .otp-col {
    max-width: 70px;
  }

  .otp-input {
    text-align: center;
    font-size: 2rem;
    padding: 0.5rem;
    border-radius: 10px;
    --highlight-color-focused: 'none';
    border: 1px solid var(--ion-color-dark);
    --color: var(--ion-color-dark);
  }

  .otp-label {
    font-size: 1rem;
    display: flex;
    justify-content: center;
    color: var(--ion-color-dark);
  }

  &.dark {
    .otp-input {
      border: 1px solid var(--ion-color-light);
      --color: var(--ion-color-light);
    }

    .otp-label {
      color: var(--ion-color-light);
    }
  }
`;
